import React from "react";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import RegisterCTA from "../../../components/buttons/RegisterCTA";
import SalesCTA from "../../../components/buttons/SalesCTA";

export default function Hero() {
  return (
    <section
      style={{
        position: "relative",
        minHeight: "88vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: "130px",
        paddingBottom: "80px",
        backgroundColor: "#0f172a",
        backgroundImage: `linear-gradient(180deg, rgba(15, 23, 42, 0.88) 0%, rgba(15, 23, 42, 0.98) 100%), url(./asset/images/banner/ending.jpg)`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container maxWidth="lg" style={{ position: "relative", zIndex: 2 }}>
        <Grid container justify="center" alignItems="center">
          <Grid item xs={12} md={10} lg={8} style={{ textAlign: "center" }}>
            {/* Top pill badge */}
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                padding: "6px 14px",
                borderRadius: "9999px",
                backgroundColor: "rgba(255, 255, 255, 0.08)",
                border: "1px solid rgba(255, 255, 255, 0.15)",
                marginBottom: "24px",
              }}
            >
              <span
                style={{
                  color: "#f1f5f9",
                  fontSize: "13px",
                  fontWeight: 500,
                }}
              >
                Aplikasi Kasir POS &amp; Self Order Terpadu
              </span>
            </div>

            {/* Headline */}
            <Typography
              variant="h1"
              style={{
                color: "#ffffff",
                fontWeight: 800,
                fontSize: "clamp(2.2rem, 5vw, 3.6rem)",
                lineHeight: 1.18,
                letterSpacing: "-0.03em",
                marginBottom: "20px",
              }}
            >
              Kelola Pesanan &amp; Transaksi Kasir Lebih Cepat
            </Typography>

            {/* Subheading */}
            <Typography
              variant="subtitle1"
              style={{
                color: "#94a3b8",
                fontSize: "clamp(1rem, 2vw, 1.15rem)",
                lineHeight: 1.65,
                maxWidth: "680px",
                margin: "0 auto 36px auto",
                fontWeight: 400,
              }}
            >
              Sistem POS kasir dan pesan mandiri lewat QR Code. Hilangkan antrian di meja kasir, percepat penyajian makanan, dan pantau penjualan secara real-time.
            </Typography>

            {/* Dual CTAs */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "12px",
                flexWrap: "wrap",
                marginBottom: "48px",
              }}
            >
              <RegisterCTA
                padding="12px 28px"
                fontSize={15}
                text="Mulai Coba Gratis"
              />
              <SalesCTA
                padding="12px 24px"
                fontSize={15}
                text="Hubungi Sales"
              />
            </div>

            {/* Clean metrics row */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "40px",
                flexWrap: "wrap",
                borderTop: "1px solid rgba(255, 255, 255, 0.1)",
                paddingTop: "32px",
                maxWidth: "600px",
                margin: "0 auto",
              }}
            >
              <div>
                <div style={{ color: "#ffffff", fontWeight: 700, fontSize: "20px", marginBottom: "2px" }}>
                  3x
                </div>
                <div style={{ color: "#94a3b8", fontSize: "13px" }}>
                  Kecepatan Pesanan
                </div>
              </div>
              <div style={{ borderLeft: "1px solid rgba(255, 255, 255, 0.1)", paddingLeft: "40px" }}>
                <div style={{ color: "#ffffff", fontWeight: 700, fontSize: "20px", marginBottom: "2px" }}>
                  100%
                </div>
                <div style={{ color: "#94a3b8", fontSize: "13px" }}>
                  Cashless &amp; QRIS
                </div>
              </div>
              <div style={{ borderLeft: "1px solid rgba(255, 255, 255, 0.1)", paddingLeft: "40px" }}>
                <div style={{ color: "#ffffff", fontWeight: 700, fontSize: "20px", marginBottom: "2px" }}>
                  24/7
                </div>
                <div style={{ color: "#94a3b8", fontSize: "13px" }}>
                  Laporan Real-time
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </Container>
    </section>
  );
}
